import { render, staticRenderFns } from "./WhatsappChatStarter.vue?vue&type=template&id=6929ed9d&scoped=true"
import script from "./WhatsappChatStarter.vue?vue&type=script&lang=js"
export * from "./WhatsappChatStarter.vue?vue&type=script&lang=js"
import style0 from "./WhatsappChatStarter.vue?vue&type=style&index=0&id=6929ed9d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6929ed9d",
  null
  
)

export default component.exports